// extracted by mini-css-extract-plugin
module.exports = {"canvas":"map-canvas-9710c1d91a47be57896da8723f78a58d"};